const s = {
  name: "Billing",
  dimensions: { width: 24, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 40" style="enable-background:new 0 0 24 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M14,7H5V5h9V7z"/>
		<path class="st0" d="M5,12h9v-2H5V12z"/>
		<path class="st0" d="M14,17H5v-2h9V17z"/>
		<path class="st0" d="M5,22h9v-2H5V22z"/>
		<path class="st0" d="M14,27H5v-2h9V27z"/>
		<path class="st0" d="M17,7h2V5h-2V7z"/>
		<path class="st0" d="M19,12h-2v-2h2V12z"/>
		<path class="st0" d="M17,17h2v-2h-2V17z"/>
		<path class="st0" d="M19,22h-2v-2h2V22z"/>
		<path class="st0" d="M17,27h2v-2h-2V27z"/>
		<path class="st0" d="M14,32H5v-2h9V32z"/>
		<path class="st0" d="M0,0h24v40h-2.4L19,37.4L16.4,40h-1.8L12,37.4L9.4,40H7.6L5,37.4L2.4,40H0V0z M2,2v35.6l3-3L8.4,38h0.2
			l3.4-3.4l3.4,3.4h0.2l3.4-3.4l3,3V2H2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Billing
};
